"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isInteger_1 = __importDefault(require("lodash/isInteger"));
function element(array, index) {
    if ((0, isInteger_1.default)(index) && index > -1 && index < array.length) {
        return array[index];
    }
    else {
        return undefined;
    }
}
exports.default = element;
